import { useState, useEffect, useRef } from 'react';

interface VideoThumbnailProps {
  src: string;
  className?: string;
  controls?: boolean;
  playsInline?: boolean;
  preload?: string;
  muted?: boolean;
}

export default function VideoThumbnail({
  src,
  className,
  controls = true,
  playsInline = true,
  preload = 'auto',
  muted = true,
}: VideoThumbnailProps) {
  const [poster, setPoster] = useState('');
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoaded = () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(video, 0, 0);
        try {
          setPoster(canvas.toDataURL('image/jpeg', 0.8));
        } catch (e) {
          console.error('Failed to capture video frame:', e);
        }
      }
    };

    video.addEventListener('loadeddata', handleLoaded);
    return () => video.removeEventListener('loadeddata', handleLoaded);
  }, []);

  return (
    <video
      ref={videoRef}
      src={src}
      controls={controls}
      playsInline={playsInline}
      preload={preload}
      muted={muted}
      poster={poster || undefined}
      className={className}
      crossOrigin="anonymous"
    />
  );
}